// removed by extract-text-webpack-plugin
module.exports = {"content":"Gada1a2","shippingDetail":"G7d0137"};